import React from "react";

export const DirectionCard = ({ image, title, description, showButton = true, hideTitle = false }) => {
  return (
    <div className="card">
      {image && <img src={image} alt={title} className="card-image" />}
        <div className="card-content">
                {!hideTitle && <h3 className="card-title">{title}</h3>}
                <p className="card-description">{description}</p>
            {showButton && (
                <a href="#contact" className="card-button page-scroll" >Оставить заявку</a>  
            )}         
        </div>
    </div>
  );
};
